import React, { useState } from 'react';
import Button from '~/app/components/Button';
import _ from 'shared/lib/gettext';

interface Props {
  selectedAssetUrl: string;
}

export default function CopyUrlButton(props: Props) {
  const { selectedAssetUrl } = props;

  const [isUrlCopied, setIsUrlCopied] = useState(false);

  const copyURL = () => {
    navigator.clipboard.writeText(selectedAssetUrl);
    setIsUrlCopied(true);
    setTimeout(() => setIsUrlCopied(false), 1000);
  };

  return (
    <Button
      secondary
      onClick={copyURL}
      disabled={!selectedAssetUrl}
    >
      { isUrlCopied ? 'URL copied' : _('COPY_URL') }
    </Button>
  );
}
